module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/kinrgy-0bc6051efcf7aaadc240da2fd2b80e78.png";